// export const READY_TO_CALL = "readyToCall";
// export const CONNECTION_READY = "connectionReady";
export const GUEST_DISCONNECTED = "guestDisconnected";
